/* Beaded-necklace builder — in-listing design studio.
   Fetches prices from the ShowOps endpoint (server computes them from the
   product's admin-only cost — this script never sees a cost), lets the customer
   pick length + clasp with a live total, and fires the build to Ulka as a
   text/email (plus a keepalive beacon that queues the draft, same as the chain
   builder). Ulka confirms availability, then sends the payment link. */
(function () {
  "use strict";
  var el = document.getElementById("ur-bead-builder");
  if (!el) return;

  var cfg = {
    productId: el.dataset.productId,
    title: el.dataset.productTitle || "necklace",
    image: el.dataset.productImage || "",
    endpoint: (el.dataset.endpoint || "https://showops.ulkarocks.com").replace(/\/$/, ""),
    token: el.dataset.token || "",
    sms: (el.dataset.sms || "8323875129").replace(/[^0-9]/g, ""),
    email: el.dataset.email || "",
    productUrl: el.dataset.productUrl || "",
  };

  var state = { length: 18, clasp: null, data: null, sent: false };

  function money(n) { return "$" + Number(n).toLocaleString("en-US"); }

  fetch(cfg.endpoint + "/api/bead-prices?product=" + encodeURIComponent(cfg.productId), { cache: "no-store" })
    .then(function (r) { if (!r.ok) throw new Error("prices " + r.status); return r.json(); })
    .then(function (data) {
      if (!data || !data.lengths || !data.clasps) throw new Error("bad payload");
      state.data = data;
      if (data.lengths.indexOf(18) === -1) state.length = data.lengths[0];
      state.clasp = data.clasps[0].slug;
      render();
    })
    .catch(function (err) {
      console.error("[bead-builder]", err);
      el.innerHTML =
        '<div class="urbb-error">The design studio is taking a moment. ' +
        '<a href="sms:' + cfg.sms + '">Text Ulka</a> and she\'ll design it with you.</div>';
    });

  function priceFor(len, slug) {
    var row = state.data.prices[String(len)];
    return row && row[slug] != null ? row[slug] : null;
  }

  function render() {
    var d = state.data;
    var h = [];
    h.push('<div class="urbb-title">Design Your Necklace <span class="urbb-new">New</span></div>');
    h.push('<div class="urbb-sub">Each necklace is designed and handcrafted for you by Ulka. A special, one-of-a-kind piece made just for you to add to your Ulka Rocks collection</div>');

    // Length
    h.push('<div class="urbb-group"><span class="urbb-label">Length</span><div class="urbb-lengths">');
    d.lengths.forEach(function (L) {
      h.push('<button type="button" class="urbb-len" data-len="' + L + '" aria-pressed="' +
        (L === state.length) + '">' + L + '"</button>');
    });
    h.push("</div></div>");

    // Clasp
    h.push('<div class="urbb-group"><span class="urbb-label">Clasp choices</span><div class="urbb-clasps">');
    d.clasps.forEach(function (c) {
      h.push('<button type="button" class="urbb-clasp" data-clasp="' + c.slug + '" aria-pressed="' +
        (c.slug === state.clasp) + '">' +
        (c.img ? '<img class="urbb-clasp-img" src="' + c.img + '" alt="' + esc(c.label) + '" loading="lazy">' : "") +
        '<span class="urbb-clasp-name">' + esc(c.label) + "</span>" +
        (c.size ? '<span class="urbb-clasp-size">' + esc(c.size) + "</span>" : "") +
        "</button>");
    });
    h.push("</div></div>");

    // Price
    h.push('<div class="urbb-price"><span class="urbb-price-label">Your customized necklace</span>' +
      '<span class="urbb-price-amt" id="urbb-amt">…</span></div>');
    h.push('<p class="urbb-price-note">Your chosen clasp is included in this price.</p>');

    // Fields
    h.push('<div class="urbb-fields">' +
      '<div class="urbb-field"><input id="urbb-first" type="text" placeholder="First name" autocomplete="given-name"></div>' +
      '<div class="urbb-field"><input id="urbb-last" type="text" placeholder="Last name" autocomplete="family-name"></div>' +
      "</div>");
    h.push('<div class="urbb-note"><textarea id="urbb-note" placeholder="Anything else? Questions, an occasion, describe your design idea, or ask about different clasp options (optional)"></textarea></div>');

    // Actions
    h.push('<div class="urbb-actions">' +
      '<button type="button" class="urbb-btn urbb-btn-primary" id="urbb-text" disabled>Text Your Design to Ulka</button>' +
      '<button type="button" class="urbb-btn urbb-btn-secondary" id="urbb-email" disabled>Email Your Design</button>' +
      "</div>");
    h.push('<p class="urbb-confirm">Ulka will confirm your final design with you and ensure that the beads and clasps are still available. Then, she will send your payment link. ' +
      "It takes her 2 to 3 weeks to finish all of the orders. Please let her know if you have any upcoming occasions needing a different timeline.</p>");
    h.push('<div id="urbb-sent"></div>');

    // Custom beyond the builder
    h.push('<p class="urbb-custom">Want to chat about a fully custom design? A different look, adding other beads, even mixing chain and beads together. ' +
      '<a href="sms:' + cfg.sms + '?body=' +
      encodeURIComponent("Hi Ulka! I'd love to chat about a custom design - " + cfg.productUrl + "\n\nMy idea: ") +
      '">Text Ulka</a> and design it together.</p>');

    el.className = "urbb";
    el.innerHTML = h.join("");
    wire();
    update();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function wire() {
    el.querySelectorAll(".urbb-len").forEach(function (b) {
      b.addEventListener("click", function () {
        state.length = Number(b.dataset.len);
        el.querySelectorAll(".urbb-len").forEach(function (x) {
          x.setAttribute("aria-pressed", String(Number(x.dataset.len) === state.length));
        });
        update();
      });
    });
    el.querySelectorAll(".urbb-clasp").forEach(function (b) {
      b.addEventListener("click", function () {
        state.clasp = b.dataset.clasp;
        el.querySelectorAll(".urbb-clasp").forEach(function (x) {
          x.setAttribute("aria-pressed", String(x.dataset.clasp === state.clasp));
        });
        update();
      });
    });
    ["urbb-first", "urbb-last"].forEach(function (id) {
      el.querySelector("#" + id).addEventListener("input", update);
    });
    el.querySelector("#urbb-text").addEventListener("click", function () { order("Text"); });
    el.querySelector("#urbb-email").addEventListener("click", function () { order("Email"); });
  }

  function currentPrice() { return priceFor(state.length, state.clasp); }
  function claspLabel() {
    var c = state.data.clasps.filter(function (x) { return x.slug === state.clasp; })[0];
    return c ? c.label : "";
  }

  function update() {
    var p = currentPrice();
    var amt = el.querySelector("#urbb-amt");
    if (amt) amt.textContent = p != null ? money(p) : "…";
    var ready = p != null && firstName() && lastName() && !state.sent;
    var t = el.querySelector("#urbb-text"), e = el.querySelector("#urbb-email");
    if (t) t.disabled = !ready;
    if (e) e.disabled = !ready;
  }

  function firstName() { var i = el.querySelector("#urbb-first"); return i ? i.value.trim() : ""; }
  function lastName() { var i = el.querySelector("#urbb-last"); return i ? i.value.trim() : ""; }
  function noteVal() { var i = el.querySelector("#urbb-note"); return i ? i.value.trim() : ""; }

  function orderText() {
    return "Hi Ulka! I designed a necklace on your site:\n" +
      "Name: " + firstName() + " " + lastName() + "\n" +
      state.length + '" ' + cfg.title + "\nClasp: " + claspLabel() +
      "\nPrice: " + money(currentPrice()) +
      (noteVal() ? "\nNote: " + noteVal() : "") +
      "\n\n" + cfg.productUrl;
  }

  function order(source) {
    var p = currentPrice();
    if (p == null || !firstName() || !lastName()) return;

    // Keepalive beacon → queues the draft (order still reaches Ulka as the
    // text/email below). text/plain skips the CORS preflight.
    try {
      fetch(cfg.endpoint + "/api/bead-orders", {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        keepalive: true,
        body: JSON.stringify({
          tk: cfg.token,
          productId: cfg.productId,
          stoneName: cfg.title,
          length: state.length,
          claspSlug: state.clasp,
          note: noteVal(),
          first: firstName(),
          last: lastName(),
          source: source,
          total: p,
          photo: cfg.image,
        }),
      }).catch(function () {});
    } catch (e) { /* the text/email is the real order; never block it */ }

    var body = encodeURIComponent(orderText());
    if (source === "Email" && cfg.email) {
      window.location.href = "mailto:" + cfg.email +
        "?subject=" + encodeURIComponent("My necklace design") + "&body=" + body;
    } else {
      window.location.href = "sms:" + cfg.sms + "?body=" + body;
    }

    state.sent = true;
    update();
    var sent = el.querySelector("#urbb-sent");
    if (sent) {
      sent.innerHTML = '<div class="urbb-sent">Your design is on its way to Ulka. ' +
        "She'll confirm it's available and send your payment link.</div>";
    }
  }
})();
